<template>
  <table class="table mb-0 table-striped">
    <thead class="bg-light">
      <tr>
        <th scope="col" class="border-0">#</th>
        <th scope="col" class="border-0">Nome</th>
        <th scope="col" class="border-0">E-mail</th>
        <th scope="col" class="text-center border-0">Supervisores</th>
        <th scope="col" class="border-0">Opções</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(row, index) in managers" :key="index">
        <td class="td-1">{{ row.id }}</td>
        <td class="td-2 link">
          <router-link
            :to="{
              name: 'admin-manager-edit',
              params: { id: row.id },
            }"
          >
            {{ row.name }}
          </router-link>
        </td>
        <td class="td-2">{{ row.email }}</td>
        <td class="td-2 text-center">{{ row.supervisors_count }}</td>
        <td class="td-2"><manager-buttons :manager="row" /></td>
      </tr>
      <tr v-if="managers.length === 0">
        <td colspan="5" class="no-content">
          Ainda não tem nenhum gerente cadastrado.
        </td>
      </tr>
    </tbody>
    <manager-imports />
  </table>
</template>

<script>
import ManagerButtons from './ManagerButtons.vue';
import ManagerImports from './ManagerImports.vue';

export default {
  components: { ManagerButtons, ManagerImports },
  name: 'manager-table',
  props: {
    managers: {
      type: Array,
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~_scss/overrides';
.td {
  &-1 {
    max-width: 60px;
  }
  &-2 {
    min-width: 140px;
    max-width: 300px;
  }
}
</style>
